import { Navigate, Route, Routes } from 'react-router-dom';
import SigningFormPage from 'src/components/SigningForm/SigningFormPage';
import StudentPage from 'src/components/StudentPage/StudentPage';
import { RoleTypes } from 'src/models/roles';
import { isAttendanceFeatureEnabled } from 'src/utils/featureFlags';
import PrivacyPolicyPage from '../Main/PrivacyPolicy/PrivacyPolicyPage';
import FormPage from '../Student/StudentForms/FormPage/FormPage';
import SupervisorClass from './SupervisorClasses/SupervisorClass/SupervisorClass';
import SupervisorClasses from './SupervisorClasses/SupervisorClasses';
import SupervisorAttendancePage from './SupervisorAttendance/SupervisorAttendancePage';

const SupervisorRouter = () => (
  <Routes>
    <Route path="/" element={<SupervisorClasses />} />
    <Route path="/class/:classId" element={<SupervisorClass />} />
    <Route
      path="/class/:classId/student/:userId"
      element={<StudentPage activeRole={RoleTypes.Advisor} />}
    />
    <Route
      path="/class/:classId/student/:studentUserId/form/:formId/assignment/:assignmentId"
      element={<FormPage />}
    />
    <Route path="/form/:formId" element={<FormPage />} />
    <Route
      path="/class/:classId/student/:studentUserId/signingform"
      element={<SigningFormPage />}
    />
    <Route
      path="/class/:classId/student/:userId/attendance"
      element={
        isAttendanceFeatureEnabled()
          ? <SupervisorAttendancePage />
          : <Navigate to="/" replace />
      }
    />
    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default SupervisorRouter;
